import {
  ExternalDocumentRefDocument,
  ExternalDocumentRefFragment,
  ExternalDocumentRefFragmentDoc,
  ExternalDocumentRefQuery,
  ExternalDocumentRefQueryVariables,
  withStandardRefHook,
} from '@spotify/confidence-graphql';

export const useExternalDocumentRef = withStandardRefHook<
  ExternalDocumentRefQuery,
  ExternalDocumentRefFragment,
  'externalDocument',
  ExternalDocumentRefQueryVariables
>(
  ExternalDocumentRefDocument,
  'externalDocument',
  ExternalDocumentRefFragmentDoc,
  'ExternalDocumentRef',
  'CollaborationV1ExternalDocument',
);
